export function FlagIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="flag-02">
        <path
          id="Icon"
          d="M2.66699 10.0007C2.66699 10.0007 3.33366 9.33398 5.33366 9.33398C7.33366 9.33398 8.66699 10.6673 10.667 10.6673C12.667 10.6673 13.3337 10.0007 13.3337 10.0007V2.66732C13.3337 2.66732 12.667 3.33398 10.667 3.33398C8.66699 3.33398 7.33366 2.00065 5.33366 2.00065C3.33366 2.00065 2.66699 2.66732 2.66699 2.66732M2.66699 14.6673L2.66699 1.33398"
          stroke={props.color || '#626266'}
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
}

export default FlagIcon;
